<template>
 <span></span>
</template>

<script>
  export default {
    name: 'ExportExcel',
    props: {
      fctProps: {
        type: String
      },
      contentProps: {
        type: Array
      }
    },
    data: () => ({
      fct: '',
      content: [],
      csvData:[]
    }),
    mounted: function(){
      this.content = this._props.contentProps;
      this.fct = this._props.fctProps;
    },
    methods: {
      getTranslation(val) {
        return this.$t(val);
      },
      projectOverview: function(){

        // Loop through `this.content` and build the csvData
        this.csvData = [
          [ this.getTranslation("Finance Sector ID"), 
            this.getTranslation("Project ID"), 
            this.getTranslation("Budget ID"), 
            this.getTranslation("Project Name"),
            //this.getTranslation("Sector"), 
            this.getTranslation("Period"), 
            //this.getTranslation("Project Owner"), 
            this.getTranslation("Location"), 
            this.getTranslation("Asset Category"), 
            this.getTranslation("Project contract value (mLAK)"), 
            this.getTranslation("Total Payment (mLAK)"), 
            this.getTranslation("Contract Payment due (mLAK)"), 
            this.getTranslation("Reporting"), 
            this.getTranslation("Status"), 
            this.getTranslation("Rating"), 
            this.getTranslation("Contractor"), 
            this.getTranslation("Need Submission Year"),
            this.getTranslation("Domain"),
            this.getTranslation("Sector"),
            this.getTranslation("Type of Investment"),
            this.getTranslation("Disaster"),
            this.getTranslation("Project Owner"),
            this.getTranslation("Project Owner Mail"),
            this.getTranslation("Project Owner Phone Number"),
            this.getTranslation("Project Owner Organization/Sector"),
            this.getTranslation("Province"),
            this.getTranslation("District"),
            this.getTranslation("Number of directly affected villages that the asset services:"), 
            this.getTranslation("Number of directly affected people that the asset services:"), 
            this.getTranslation("% of people in the district living below the poverty line:"), 
            this.getTranslation("Assessed Value (mLAK)"), 
            this.getTranslation("National Assembly Value (mLAK)"),
            this.getTranslation("Budget Current Year (mLAK)"), 
            this.getTranslation("On Debt"),
            this.getTranslation("Other Fund (mLAK)"), 
            this.getTranslation("Work performed value (mLAK)"), 
            this.getTranslation("Work Performed (mLAK)"), 
            this.getTranslation("Payment (mLAK)"), 
            this.getTranslation("Date")
          ]
        ];

        this.content.forEach(project => {

          var fincanceId = '';
          var projectId = '';
          var budgetId = '';
          if(project.finance_sector_number !== null){
            fincanceId = ' ' + project.finance_sector_number.toString() + ' ';
          }else{
            fincanceId = '/';
          }
          if(project.project_number !== null){
            projectId = ' ' + project.project_number.toString()+ ' ';
          }else{
            projectId = '/';
          }
          if(project.budget_number !== null){
            budgetId = ' ' + project.budget_number.toString()+ ' ';
          }else{
            budgetId = '/';
          }

          const projectName = project.project_need.name_en;
          //const sector = project.project_need.domain.translation.name;
          const period = `${new Date(project.project_start_date).toLocaleDateString()} - ${new Date(project.project_end_date).toLocaleDateString()}`;
          //const projectOwner = project.project_need.project_owner.translation.name;
          const location = project.project_need.province.translation.name; 
          const assetCategory = project.project_need.asset_type.translation.name;
          const contractValue = parseFloat(project.contract_cost);
          const totalPayment = project.payment_list.reduce((acc, payment) => acc + payment.expense_amount, 0);
          const paymentDue = contractValue - totalPayment;
          
          var reporting = '';
          if(project.project_reportings.length !== 0){
            project.project_reportings.forEach((report, index) => {
              reporting += this.getTranslation(report.name);
              if(report.validated){
                reporting += ' (V)';
                }else{
                  reporting += ' (X)';
                }
                if(index < project.project_reportings.length-1){
                  reporting += ' / ';
                }
            })
          }

          const status = project.project_status.translation.name;
          const projectMark = project.project_mark.name + ' (' + `${new Date(project.evaluation_document_deadline).toLocaleDateString()}` + ')';
          var contractor = '';
          if(project.contractor !== null){
            contractor = project.contractor.name;
          }else{
           contractor = '/';
          }

          const planYear = project.project_need.year.name;
          const planDomain = this.getTranslation(project.project_need.domain.translation.name);
          const planSector = this.getTranslation(project.project_need.project_sector.translation.name);
          const planType = this.getTranslation(project.project_need.project_type.translation.name);
          var planDisaster = "";
          if(project.project_need.disaster_category !== null && project.project_need.event_year !== null){
            planDisaster += this.getTranslation(project.project_need.disaster_category.translation.name) + ' ' + this.getTranslation(project.project_need.event_year.name) ;
          }else{
            planDisaster += "/";
          }
          const planOwner = this.getTranslation(project.project_need.project_owner.translation.name);
          const planMail = project.project_need.project_owner.mail ;
          const planPhone = project.project_need.project_owner.phone_number ;
          const planOrga = project.project_need.project_owner.organization;
          var planProvince = "";
          if(project.project_need.province !== null){
            planProvince += project.project_need.province.translation.name;
          }
          var planDistrict = "";
          if(project.project_need.project_need_districts.length !== 0){
            for(var j=0; j < project.project_need.project_need_districts[j].length; j++){
                planDistrict += project.project_need.project_need_districts[j].district.translation.name + ' / ';
            }
          }

          var affected_village_consulted_vfm_number, affected_people_consulted_vfm_number, people_poverty_vfm_percent;
            if(project.affected_village_consulted_vfm_number !== null){
              affected_village_consulted_vfm_number = project.affected_village_consulted_vfm_number;
            }else{
              affected_village_consulted_vfm_number = 0;
            }
            if(project.affected_people_consulted_vfm_number !== null){
              affected_people_consulted_vfm_number = project.affected_people_consulted_vfm_number;
            }else{
              affected_people_consulted_vfm_number = 0;
            }
            if(project.people_poverty_vfm_percent !== null){
              people_poverty_vfm_percent = project.people_poverty_vfm_percent;
            }else{
              people_poverty_vfm_percent = 0;
            }

          // Placeholder values for finance and other categories
          var financeAssessed = project.estimated_cost + this.getTranslation('mLAK') + ' ' + this.getTranslation('Cost Category') + ': ';
          if(project.estimated_cost/1000 < 20){
            financeAssessed += this.$store.state.referentials.projectClassList.filter(o => o.id === 5)[0].translation.name;
          }else if(project.estimated_cost/1000 >= 20 && project.estimated_cost/1000 < 100){
            financeAssessed += this.$store.state.referentials.projectClassList.filter(o => o.id === 4)[0].translation.name;
          }else if(project.estimated_cost/1000 >= 100 && project.estimated_cost/1000 < 200){
            financeAssessed += this.$store.state.referentials.projectClassList.filter(o => o.id === 3)[0].translation.name;
          }else if(project.estimated_cost/1000 >= 200 && project.estimated_cost/1000 < 400){
            financeAssessed += this.$store.state.referentials.projectClassList.filter(o => o.id === 2)[0].translation.name;
          }else{
            financeAssessed += this.$store.state.referentials.projectClassList.filter(o => o.id === 1)[0].translation.name;
          }

          const nationalValue = project.national_assembly_cost + " " + this.getTranslation('mLAK');

          var budgetYear = '';
          if(project.budget_current_years.length !== 0){
              for(var j=0; j < project.budget_current_years.length; j++){
                budgetYear += project.budget_current_years[j].amount + ' ' + this.getTranslation('mLAK') + ' (' + this.getTranslation('Year: ') + project.budget_current_years[j].year.name + ') / ';
              }
            }

          var onDebt;
            if(project.on_debt){
              onDebt = 'Yes';
            }else{
              onDebt = 'No';
            }


          var otherFunds = '';
          if(project.project_budget_other_funding.length !== 0){ //total_other_project_funds
              otherFunds += project.total_other_project_funds + ' ( ';

              for(var j=0; j < project.project_budget_other_funding.length; j++){
                otherFunds += project.project_budget_other_funding[j].amount + ' ' + this.getTranslation('mLAK') + ' (' + `${new Date(project.project_budget_other_funding[j].createdAt).toLocaleDateString()}`  + ') / ';
              }
              otherFunds += ' )';

            }else{
              otherFunds = 0;
            }

            var totalWorkPerformed = project.total_work_value;

            var workPerformed = "";
            var workPayment = "";
            var workDate = "";

            if(project.project_works && project.project_works.length !== 0){
              for(var j=0; j < project.project_works.length; j++){
                workPerformed += project.project_works[j].work_value + " " + this.getTranslation('mLAK') + ' / ';
                  for(var k=0; k < project.project_works[j].work_expenses.length; k++){
                    workPayment += project.project_works[j].work_expenses[k].expense_amount + " " + this.getTranslation('mLAK') + ' / ';
                    workDate += `${new Date(project.project_works[j].work_expenses[k].createdAt).toLocaleDateString()}` + ' - ';
                  }
                }
            }

          // Add row to the projectOverviewData
          this.csvData.push([
            fincanceId, 
            projectId, 
            budgetId, 
            projectName, 
            //sector, 
            period, 
            //projectOwner, 
            location, 
            assetCategory, 
            contractValue, 
            totalPayment, 
            paymentDue,
            reporting,
            status, 
            projectMark, 
            contractor,
            planYear,
            planDomain,
            planSector,
            planType,
            planDisaster,
            planOwner,
            planMail,
            planPhone,
            planOrga,
            planProvince,
            planDistrict, 
            affected_village_consulted_vfm_number, 
            affected_people_consulted_vfm_number,
            people_poverty_vfm_percent,
            financeAssessed, 
            nationalValue,
            budgetYear, 
            onDebt,
            otherFunds, 
            totalWorkPerformed, 
            workPerformed,
            workPayment,
            workDate
          ]);
        });

      },

      projectApplication: function(){

        console.log('****this.content', this.content);

        // Loop through `this.content` and build the csvData
        this.csvData = [
          [ this.getTranslation("Project name and location"), 
            this.getTranslation("Description"), 
            this.getTranslation("Need Submission Year"), 
            this.getTranslation("Province"), 
            this.getTranslation("District"), 
            this.getTranslation("Domain"),
            this.getTranslation("Type of Investment"), 
            this.getTranslation("Sector"), 
            this.getTranslation("Event"), 
            this.getTranslation("Project Owner"), 
            this.getTranslation("Cost (mLAK)"), 
            this.getTranslation("Assessed Value (mLAK)"), 
            this.getTranslation("Rating"), 
            this.getTranslation("Status"), 
            this.getTranslation("National Assembly"),
            this.getTranslation("Document"), 
            this.getTranslation("Covering disaster area"),
            
          ]
        ];

        this.content.forEach(project => {

          var name_en = '';
          var plan_description = '';
          var plan_year = '';
          var assesessValue = '';
          var province = '';
          var district = '';
          var domaine = '';
          var type = '';
          var sector = '';
          var event = '';
          var projectOwner = '';
          var estimatedCost = '';
          var rating = '';
          var status = '';
          var nationalAssembly = '';
          var projectDocument = '';
          var disasterCoverage = '';

          if(project.project_need.name_en !== null){
            name_en = project.project_need.name_en;
          }else{
            name_en = '/';
          }
          if(project.project_need.description !== null){
            plan_description = project.project_need.description;
          }else{
            plan_description = '/';
          }
          if(project.project_need.year.name !== null){
            plan_year = project.project_need.year.name;
          }else{
            plan_year = '/';
          }
          if(project.estimated_cost !== null){
            if (Number.isInteger(project.estimated_cost)) {
              assesessValue = project.estimated_cost.toFixed(2);  // Ajoute .00
            } else {
              assesessValue = project.estimated_cost.toString();  // Garde tel quel
            }
          }else{
            assesessValue = 0;
          }
          if(project.project_need.province.translation.name !== null){
            province = project.project_need.province.translation.name;
          }else{
            province = '/';
          }
          if(project.project_need.project_need_districts.length !== 0){
            project.project_need.project_need_districts.forEach((dis, index) => {
              district += this.getTranslation(dis.district.translation.name);
                if(index < project.project_need.project_need_districts.length-1){
                  district += ' / ';
                }
            })
            //district = project.project_need.province.translation.name;
          }else{
            district = '/';
          }
          if(project.project_need.domain.translation.name !== null){
            domaine = project.project_need.domain.translation.name;
          }else{
            domaine = '/';
          }
          if(project.project_need.project_type.translation.name !== null){
            type = project.project_need.project_type.translation.name;
          }else{
            type = '/';
          }
          if(project.project_need.project_sector.translation.name !== null){
            sector = project.project_need.project_sector.translation.name;
          }else{
            sector = '/';
          }
          if(project.project_need.disaster_category_id !== null){
            event = this.getTranslation(project.project_need.disaster_category.translation.name);
          }else{
            event = '/';
          }
          if(project.project_need.event_year_id !== null){
            event += '(' + project.project_need.event_year.name + ')';
          }else{
            event += '/';
          }
          if(project.project_need.project_owner_id !== null){
             projectOwner = this.getTranslation(project.project_need.project_owner.translation.name);
          }else{
             projectOwner = '/';
          }
          if(project.project_need.cost !== null){
            if (Number.isInteger(project.project_need.cost)) {
              estimatedCost = project.project_need.cost.toFixed(2);  // Ajoute .00
            } else {
              estimatedCost = project.project_need.cost.toString();  // Garde tel quel
            }
          }else{
            estimatedCost = 0;
          }
          if(project.project_mark.name !== null){
            rating = project.project_mark.name + '('+ `${new Date(project.evaluation_document_deadline).toLocaleDateString()}` +')';
          }else{
            rating = '/';
          }
          if(project.project_status.translation.name !== null){
            status = project.project_status.translation.name;
          }else{
            status = '/';
          }
          if(project.validated_by_national_assembly){
                nationalAssembly = 'Yes';
          }else{
            nationalAssembly = 'No';
          }
          if(project.instruction_document_missing){
            projectDocument = this.getTranslation('Partial');
          }else{
            projectDocument = this.getTranslation('Complete');
          }
          if(project.covering_disaster_area){
            disasterCoverage = 'Yes';
          }else{
            disasterCoverage = 'No';
          }

          // Add row to the csvData
          this.csvData.push([
            name_en,
            plan_description,
            plan_year,
            province,
            district,
            domaine,
            type,
            sector,
            event,
            projectOwner,
            estimatedCost,
            assesessValue,
            rating,
            status,
            nationalAssembly,
            projectDocument,
            disasterCoverage
          ]);
        });

      },
      createExcel: function(){

        this.content = this._props.contentProps;

        if(this.fct === 'Project Overview'){
          this.projectOverview();
        }else if(this.fct === 'Project Application'){
          this.projectApplication()
        }


        const csv = this.csvData.map(row =>
          row.map(cell => {
            // Keep numbers as-is and only quote non-numeric values
            return `"${cell.toString().trim().replace(/"/g, '""')}"`;
          }).join(",")
        ).join("\n");

        // Add BOM to support Lao characters
        const utf8Bom = "\uFEFF";

        // Create a Blob object
        const blob = new Blob([utf8Bom + csv], { type: "text/csv;charset=utf-8;" });

        // Create a downloadable link
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", this.fct+".csv");

        // Trigger the download
        link.click();

      },
    }
  }
</script>
